import { EpModal, hideModal } from '../../../../components/EpModal';
import { useTranslation as t } from '../../../../hooks/useTranslation';
import styles from './EpSentinelEventModal.module.scss';
import Parser from 'html-react-parser';

interface IEpEventSentinelModal {
  translations: unknown;
}

export const EpEventSentinelModal = ({
  translations,
}: IEpEventSentinelModal) => {
  return (
    <EpModal
      modalId="event-sentinel-modal"
      modalTitle={t(translations, 'Sentinel event (JCI)')}
      modalType="default"
      modalSize="md"
      modalButtonList={[
        {
          buttonId: 'modal__button--close',
          buttonText: t(translations, 'Cancel'),
          buttonType: 'secondary-outline',
          buttonSize: 'md',
          isCloseButton: true,
        },
        {
          buttonId: 'modal__button--save',
          buttonText: t(translations, 'Confirm'),
          buttonType: 'primary',
          isCloseButton: false,
          buttonSize: 'md',
          buttonLeftIconName: 'SolidCheck',
          buttonOnClickFunc: () => hideModal('event-sentinel-modal'),
        },
      ]}
    >
      <div style={{ height: 'max-content' }}>
        <div>
          <h4 className={styles['content__title']}>
            {t(translations, 'What is serious temporary injury/disability?')}
          </h4>
          <p className={styles['content__text']}>
            {Parser(
              t(
                translations,
                'It is a potentially fatal event, with limited duration without permanent consequence, requiring transfer to a higher level of care due to life-threatening condition or prolonged monitoring (e.g.surgery, procedure or additional treatment).',
              ),
            )}
          </p>
        </div>

        <div>
          <h4 className={styles['content__title']}>
            {t(translations, 'What is permanent injury/disability?')}
          </h4>
          <p className={styles['content__text']}>
            {Parser(
              t(
                translations,
                'A continuous condition resulting from physical or psychological illness or injury that prevents an individual from performing some or all of the functions of his or her occupation (e.g. loss of limb or function).',
              ),
            )}
          </p>
        </div>
      </div>
    </EpModal>
  );
};
